export default ['Type 1',
'Type 2',
'Type 3']
